import React, { useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { authHeader, handleResponse } from "../Services/fack.backend";
import AdminContext from "../Helper/admin";
import Loader from '../Layout/Loader'

const PrivateRoute = () => {
  const { user, isLoading } = useContext(AdminContext)

  return isLoading ? <Loader /> : user ? (
    <Outlet />
  ) : (
    <Navigate exact to={`${process.env.PUBLIC_URL}/login`} />
  );
};

export default PrivateRoute;